import React, { ChangeEvent, Component } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IFishbowlGetUsersDTO from "../../../models/DTO/IFishbowlGetUsersDTO";
import IOnFishbowlGetUsersDTO from "../../../models/DTO/IOnFishbowlGetUsersDTO";
import IOnProcessRepGroupDTO from "../../../models/DTO/IOnProcessRepGroupDTO";
import { IProcessRepGroupDTO } from "../../../models/DTO/IProcessRepGroupDTO";
import IUpdateTokenConfigurationDTO from "../../../models/DTO/IUpdateTokenConfigurationDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IFishbowlUser from "../../../models/Fishbowl/IFishbowlUser";
import IConnection_Token from "../../../models/IConnection_Token";
import INotification from "../../../models/INotification";
import IRepGroup from "../../../models/IRepGroup";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OwButton from "../OwButton/OwButton";
import OwLabel from "../OwLabel/OwLabel";
import OwSelectOption from "../OwSelectOption/OwSelectOption";
import OwTitle from "../OwTitle/OwTitle";
import "./FishbowlAssignUser.scss";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    repGroup?: IRepGroup;
    supplierUserToken?: IConnection_Token;
};

type State = {
    activeGetUsers: boolean;
    users: IFishbowlUser[];
    fishbowl_user_id?: string;
    saveActive: boolean;
};

class FishbowlAssignUser extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        let fishbowl_user_id: string | undefined;

        if (this.props.supplierUserToken?.fishbowl_user_id) {
            fishbowl_user_id = this.props.supplierUserToken.fishbowl_user_id;
        } else if (this.props.repGroup?.fishbowl_user_id) {
            fishbowl_user_id = this.props.repGroup.fishbowl_user_id;
        }

        this.state = {
            activeGetUsers: false,
            users: [],
            fishbowl_user_id,
            saveActive: false,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.FishbowlOnGetUsers, this.onGetUsers);
        this.props.socket.on(EndpointsEnum.TokenOnUpdateTokenConfiguration, this.onUpdateToken);
        this.props.socket.on(EndpointsEnum.RepGroupOnProcessRepGroup, this.onProcessRepGroup);

        this.getUsers();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.FishbowlOnGetUsers, this.onGetUsers);
        this.props.socket.removeListener(EndpointsEnum.TokenOnUpdateTokenConfiguration, this.onUpdateToken);
        this.props.socket.removeListener(EndpointsEnum.RepGroupOnProcessRepGroup, this.onProcessRepGroup);
    }

    getUsers = () => {
        const payload: IFishbowlGetUsersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.FishbowlGetUsers, payload);

        this.setState({
            activeGetUsers: true,
        });
    };

    onGetUsers = (data: IOnFishbowlGetUsersDTO) => {
        this.setState({
            users: data.users,
            activeGetUsers: false,
        });
    };

    processRepGroup = (fishbowl_user_id?: string) => {
        if (this.props.repGroup) {
            const payload: IProcessRepGroupDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                // @ts-expect-error
                repGroup: {
                    guid: this.props.repGroup.guid,
                    fishbowl_user_id,
                },
            };

            this.props.socket.emit(EndpointsEnum.RepGroupProcessRepGroup, payload);

            this.setState({
                saveActive: true,
            });
        }
    };

    onProcessRepGroup = (data: IOnProcessRepGroupDTO) => {
        const notification: INotification = {
            message: "successfully_updated_rep_group",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            saveActive: false,
        });
    };

    updateToken = (fishbowl_user_id?: string) => {
        if (this.props.supplierUserToken) {
            const payload: IUpdateTokenConfigurationDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                tokenGuid: this.props.supplierUserToken.guid,
                fishbowl_user_id,
            };

            this.props.socket.emit(EndpointsEnum.TokenUpdateTokenConfiguration, payload);

            this.setState({
                saveActive: true,
            });
        }
    };

    onUpdateToken = (data: IConnection_Token) => {
        const notification: INotification = {
            message: "successfully_updated_user",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            saveActive: false,
        });
    };

    closeModal = () => {
        this.props.closeModalFn();
    };

    saveAssignment = () => {
        const fishbowl_user_id = this.state.fishbowl_user_id;

        if (this.props.supplierUserToken) {
            this.updateToken(fishbowl_user_id);
        } else {
            this.processRepGroup(fishbowl_user_id);
        }
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    renderUser = (option: IFishbowlUser): string => {
        return `${option.userName} - ${option.lastName}, ${option.firstName}`;
    };

    render() {
        return (
            <div className={"FishbowlAssignUser p-2"}>
                <div className={"w-100"} style={{ height: "2rem" }}>
                    <div className={"d-flex justify-content-between"}>
                        <OwTitle leftIconName={"fad fa-exchange"} title={"assign_user"} tag={"h3"} />
                        <div>
                            <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.closeModal} />
                        </div>
                    </div>
                </div>

                <div className={"mt-3"}>
                    <OwLabel title={"fishbowl_user"} />
                    <div>
                        <OwSelectOption
                            name={"fishbowl_user_id"}
                            titleRenderFn={this.renderUser}
                            titleProp={"name"}
                            valueProp={"id"}
                            options={this.state.users}
                            fn={this.handleChange}
                            selectedOption={this.state}
                            selectedOptionProp={"fishbowl_user_id"}
                        />
                    </div>
                </div>

                <div className={"mt-3"}>
                    <OwButton title={"save"} fn={this.saveAssignment} active={this.state.saveActive} disableOnActive={true} />
                </div>
            </div>
        );
    }
}

export default FishbowlAssignUser;
